<div class="pt-4 d-flex-inline p-4">
  <h4 class="float-start d-flex">
    Select campaign phases to connect to or disconnect from
  </h4>
  <button
    class="float-end d-flex btn btn-sm rounded hover:bg-gray-200"
    (click)="closeDialog()"
  >
    <i class="pi pi-times mt-1"></i>
  </button>
</div>

<div mat-dialog-content>
  <div class="campaign-list-scroll">
    <input
      type="text"
      placeholder="Search campaigns..."
      [formControl]="searchControl"
      class="form-control mb-3"
    />

    <div class="campaign-list pb-4">
      <form (ngSubmit)="onSubmit()">
        <div class="campaign-list-scroll">
          <ul class="list-group">
            <li *ngFor="let campaign of campaigns" class="list-group-item">
              <div class="campaign-item">
                <!-- Campaign Header -->
                <div class="d-flex align-items-center mb-2">
                  <label class="cursor-pointer fw-bold">
                    {{ campaign.campaignName }}
                  </label>
                  <span class="badge bg-secondary ms-2">
                    {{ getSelectedPhaseCount(campaign) }}/{{
                      getPhaseCount(campaign)
                    }}
                    phases
                  </span>
                </div>

                <!-- Select all phases -->
                <div *ngIf="campaign.phases && campaign.phases.length > 0">
                  <div class="d-flex align-items-center mb-2">
                    <p-checkbox
                      [binary]="true"
                      [ngModel]="isAllPhasesSelected(campaign)"
                      (onChange)="toggleAllPhases(campaign, $event)"
                      inputId="all_{{ campaign?.campaignId }}"
                      name="all_{{ campaign?.campaignId }}"
                    />
                    <label
                      for="all_{{ campaign?.campaignId }}"
                      class="cursor-pointer small text-muted ms-2"
                    >
                      Select all phases
                    </label>
                  </div>

                  <!-- Phases List -->
                  <div class="container ml-3">
                    <div
                      class="phases-list row justify-content-center align-items-center"
                    >
                      <div
                        *ngFor="let phase of campaign.phases"
                        class="phase-item col-12 d-flex align-items-center"
                      >
                        <p-checkbox
                          [(ngModel)]="campaign.selectedPhaseIds"
                          [value]="phase.phaseId"
                          inputId="phase_{{ campaign?.campaignId }}_{{
                            phase.phaseId
                          }}"
                          name="phase_{{ campaign?.campaignId }}_{{
                            phase.phaseId
                          }}"
                          class="small-checkbox"
                        />
                        <label
                          for="phase_{{ campaign?.campaignId }}_{{
                            phase.phaseId
                          }}"
                          class="cursor-pointer d-flex align-items-center ms-2 mb-0"
                        >
                          <span class="badge bg-primary me-2">{{
                            phase.phaseOrder
                          }}</span>
                          {{ phase.phaseName }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- No Phases Message -->
                <div
                  *ngIf="!campaign.phases || campaign.phases.length === 0"
                  class="ms-4 text-muted small"
                >
                  <em>No phases in this campaign</em>
                </div>
              </div>
            </li>

            <li
              *ngIf="campaigns.length === 0"
              class="list-group-item text-muted"
            >
              No campaigns found.
            </li>
          </ul>
        </div>

        <div class="w-full">
          <button type="submit" class="btn btn-primary mt-3 mb-3 w-full">
            <i class="pi pi-check me-2"></i>Done
          </button>
        </div>
      </form>

      <!-- Pagination -->
      <p-paginator
        [rows]="rows"
        [totalRecords]="totalRecords"
        [first]="first"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[5, 10, 20]"
        dropdownAppendTo="body"
        class="mt-3"
      >
      </p-paginator>
    </div>
  </div>
</div>

<!-- Styles for phase list -->
<style>
  .small-checkbox ::ng-deep .p-checkbox .p-checkbox-box {
    width: 1.2rem;
    height: 1.2rem;
  }

  .small-checkbox ::ng-deep .p-checkbox .p-checkbox-box .p-checkbox-icon {
    font-size: 0.8rem;
  }

  .phase-item {
    padding: 4px 0;
  }
</style>
